module.exports = __webpack_public_path__ + "static/img/Free-ROI-Widget@2x.09d0e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module/img/widget/Free-ROI-Widget@2x.png
// module id = XkyD
// module chunks = 1